import styled from 'styled-components';
import DynamicFormQuestion from './DynamicFormQuestion';
import { media } from 'utils/style';

export default styled(DynamicFormQuestion)`
  ${media.greaterThan('tablet')`
      grid-column: 1 / span 3;
    `}
  .dynamic-form-question {
  }
`;
